import { Checkbox } from "@/components/ui/checkbox";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { ChevronDownIcon } from "lucide-react";

export function MultiSelect({
  options = [],
  value = [],
  onChange,
  placeholder,
  disabled,
}) {
  const toggleValue = (id, isDisabled = false) => {
    if (disabled || isDisabled) return;
    onChange(
      value.includes(id) ? value.filter((v) => v !== id) : [...value, id]
    );
  };

  const selectedNames = options
    .filter((option) => value.includes(option.id))
    .map((option) => option.name)
    .join(", ");

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            "w-full justify-between bg-background text-black hover:bg-background hover:text-black text-wrap min-h-[36px] h-auto",
            disabled && "cursor-not-allowed"
          )}
          disabled={disabled}
        >
          <p className="text-wrap h-full">
            {value.length > 0 ? selectedNames : placeholder || "Select options"}
          </p>
          <ChevronDownIcon className="text-muted-foreground pointer-events-none size-4 shrink-0 translate-y-0.5 transition-transform duration-200" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-full shadow-lg rounded-md max-h-60 overflow-y-auto bg-background text-black hover:bg-background hover:text-black">
        {options.map((option) => (
          <div
            key={option?.id}
            onClick={() => toggleValue(option?.id, option?.disabled)}
            className={cn(
              "flex items-center space-x-2 px-2 py-1 cursor-pointer rounded",
              disabled || (option?.disabled && "opacity-50 cursor-not-allowed")
            )}
          >
            <Checkbox
              className="bg-white me-1"
              checked={value.includes(option?.id)}
              disabled={option?.disabled}
            />
            <span
              className={cn(
                "text-sm",
                value.includes(option?.id) && "font-medium"
              )}
            >
              {option?.name}
            </span>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
}
